module.exports = __webpack_public_path__ + "static/img/yes.059f972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yes.png
// module id = 1Wzo
// module chunks = 1